import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yandex-international': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M129.5 512v-166.1l-111-297.9h55.8l81.8 229.7 94.1-277.7h51.3l-120.7 347.8v164.2h-51.3z'
      }
    ]
  }
})
